'use client'

function excludeProps(expectedProps) {
  return { shouldForwardProp: (prop) => !expectedProps.includes(prop) };
}

export { excludeProps };
//# sourceMappingURL=filterProps.mjs.map
